import { render, staticRenderFns } from "./ContactWithChildBestInterestsOfChild.vue?vue&type=template&id=35890359"
import script from "./ContactWithChildBestInterestsOfChild.vue?vue&type=script&lang=ts"
export * from "./ContactWithChildBestInterestsOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports